import { ReactNode } from 'react';

interface PanelHeaderProps {
  eyebrow: string;
  title: string;
  icon?: ReactNode;
  aside?: ReactNode;
  deleteLabel?: string;
  onDelete?: () => void;
}

const PanelHeader = ({ eyebrow, title, icon, aside, deleteLabel, onDelete }: PanelHeaderProps) => (
  <div className="flex items-start justify-between gap-4">
    <div className="min-w-0">
      <p className="text-xs font-medium text-neutral-50">{eyebrow}</p>
      <div className="flex items-center gap-3 mt-1">
        {icon}
        <h2 className="text-2xl font-bold text-neutral-90 break-words">{title}</h2>
        {aside}
      </div>
    </div>
    {onDelete && (
      <button
        type="button"
        onClick={onDelete}
        className="flex items-center gap-1.5 shrink-0 text-sm font-semibold text-danger-60 hover:text-danger-40"
      >
        <img src="/icons/trash.svg" alt="" className="w-4 h-4" />
        {deleteLabel}
      </button>
    )}
  </div>
);

export default PanelHeader;
